export const SET_STATE = "SET_STATE"
export const ADD_FAVORITE = "ADD_FAVORITE"